import {
  Map,
  AdvancedMarker,
  /* useAdvancedMarkerRef,
  useMap,
  useMapsLibrary,
  ControlPosition,
  MapControl, */
  Pin,
} from "@vis.gl/react-google-maps";

import useAddressContext from "../../hooks/useAddressContext";
import { googleMapId } from "./ProvidersLocationMap";

const GoogleMap = () => {
  const { currentCoordinate } = useAddressContext();

  return (
    <Map
      style={{ width: "100%", height: "200px" }}
      center={currentCoordinate}
      zoom={14}
      zoomControl={true}
      mapId={googleMapId}
      streetViewControl={false}
      //fullscreenControl={false}
      gestureHandling="greedy"
      disableDefaultUI={true}
    >
      <div
        className="absolute"
        style={{
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10,
          pointerEvents: "none",
        }}
      >
        <span className="relative flex h-20 w-20">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teriary opacity-75"></span>
          <span className="relative inline-flex rounded-full h-20 w-20 bg-[#15abbc] opacity-20"></span>
        </span>
      </div>
      <AdvancedMarker position={currentCoordinate}>
        <Pin
          background={" #15abbc"}
          borderColor={"#15abbc"}
          glyphColor={"#233D4A"}
        />
      </AdvancedMarker>
    </Map>
  );
};

export default GoogleMap;
